import { Controller } from "@hotwired/stimulus";

export default class FormChangeController extends Controller {
  static targets = ["submit"];

  connect() {
    this.form = this.element.querySelector("form") || this.element;

    if (!this.form) return;

    this.initialValues = {};

    for (const field of Array.from(this.form.elements)) {
      if (!field.name || field.type === "hidden") continue;

      if (field.type === "checkbox" || field.type === "radio") {
        this.initialValues[field.name] = field.checked;
      } else {
        this.initialValues[field.name] = this.normalizeFieldValue(field);
      }
    }
    this.changed = false;

    this.disableButton();
    this.form.addEventListener("input", () => this.checkForChanges());
    this.form.addEventListener("change", () => this.checkForChanges());

    $(this.form).on("select2:select select2:unselect", (e) => {
      this.checkForChanges();
    });

    // check the input tags field
    for (const el of this.form.querySelectorAll("input[data-controller*=\"tags-input\"]")) {
      $(el).on("change", () => this.checkForChanges());
    }

    this.form.addEventListener("cropper:image-changed", () => {
      this.changed = true;
      this.enableButton();
    });

    this.form.addEventListener("filepond:image-changed", () => {
      this.changed = true;
      this.enableButton();
    });
  }

  checkForChanges() {
    this.changed = false;

    Array.from(this.form.elements).some((field) => {
      if (!field.name || field.type === "hidden" || field.disabled) return false;

      if (field.type === "checkbox" || field.type === "radio") {
        if (field.checked !== this.initialValues[field.name]) {
          this.changed = true;
          return true;
        }
      } else {
        const currentValue = this.normalizeFieldValue(field);
        const initialValue = this.initialValues[field.name];

        if (currentValue !== initialValue) {
          this.changed = true;
          return true;
        }
      }

      return false;
    });

    this.changed ? this.enableButton() : this.disableButton();
  }

  confirmClose(event) {
    if (!this.changed) {
      this.closeModal();
      return;
    }

    event.preventDefault();

    // show edit Post confirmation modal
    this.showDiscardConfirmation();
  }

  closeModal() {
    const modal = this.element.closest(".modal");

    if (modal) {
      bootstrap.Modal.getInstance(modal)?.hide();
    }
  }

  showDiscardConfirmation() {
    Swal.fire({
      customClass: {
        popup: "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      title: "Discard changes?",
      text: "You have unsaved changes. If you proceed, your changes will be discarded.",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Discard",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.closeModal();
      }
    });
  }

  disableButton() {
    if (!this.hasSubmitTarget) return;

    this.submitTarget.setAttribute("disabled", true);
    this.submitTarget.classList.add("opacity-50");
  }

  enableButton() {
    if (!this.hasSubmitTarget) return;

    this.submitTarget.removeAttribute("disabled");
    this.submitTarget.classList.remove("opacity-50");
  }

  normalizeFieldValue(field) {
    if (field.classList.contains("phone-form-control")) {
      return field.value.replaceAll(/\D/g, "");
    }

    return field.value;
  }
}
